import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const DetailsFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M17.7145 18.3166C18.1317 17.7265 18.3878 17.0175 18.3878 16.2546C18.3878 14.291 16.7549 12.6681 14.7812 12.6681C12.8076 12.6681 11.1746 14.291 11.1746 16.2546C11.1746 18.2183 12.8077 19.8513 14.7812 19.8513C15.4418 19.8513 16.0594 19.662 16.5987 19.3459L18.8329 21.5801L19.9054 20.5076L17.7145 18.3166H17.7145ZM14.7812 18.4112C13.6069 18.4112 12.6146 17.4236 12.6146 16.2546C12.6146 15.0911 13.6069 14.1081 14.7812 14.1081C15.9557 14.1081 16.9478 15.0911 16.9478 16.2546C16.9478 17.1241 16.2979 18.4112 14.7812 18.4112ZM6.46008 18.2001V5.72009H11.3201V9.94012H15.54V11.3046C16.1282 11.394 16.6766 11.5861 17.18 11.86V8.74011L12.5201 4.08008H4.82007V19.8401H11.2457C10.7723 19.3751 10.389 18.8201 10.1277 18.2001H6.46009L6.46008 18.2001Z"
      />
    </SvgIcon>
  );
});
